(() => {
  const SELECTORS = {
    section: '[data-sbv-section]',
    card: '[data-sbv-card]',
    swiper: '[data-sbv-swiper]',
  };

  function ensureAutoplay(video, card) {
    if (!video) return;

    const posterUrl = card && card.getAttribute('data-sbv-poster');
    if (posterUrl) {
      try {
        video.setAttribute('poster', posterUrl);
      } catch (e) {}
    }

    try {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.playsInline = true;
      video.loop = true;
    } catch (e) {}

    const tryPlay = () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {});
      }
    };

    tryPlay();
    video.addEventListener('loadedmetadata', tryPlay, { once: true });
    video.addEventListener('canplay', tryPlay, { once: true });
  }

  function initSection(sectionEl) {
    const cards = sectionEl.querySelectorAll(SELECTORS.card);
    cards.forEach((card) => {
      const video = card.querySelector('video.shop-by-videos__video');
      ensureAutoplay(video, card);
    });

    const swiperRoot = sectionEl.querySelector(SELECTORS.swiper);
    if (!swiperRoot) return;

    const mq = window.matchMedia('(max-width: 749px)');
    let swiperInstance = null;

    const mountSwiper = () => {
      if (!mq.matches) return;
      if (swiperInstance) return;
      if (!window.Swiper) return;

      swiperInstance = new window.Swiper(swiperRoot, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: false,
        watchOverflow: true,
      });
    };

    const unmountSwiper = () => {
      if (!swiperInstance) return;
      try {
        swiperInstance.destroy(true, true);
      } catch (e) {}
      swiperInstance = null;
    };

    const onChange = () => {
      if (mq.matches) mountSwiper();
      else unmountSwiper();
    };

    onChange();
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
  }

  function initAll() {
    document.querySelectorAll(SELECTORS.section).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
